//Create Namespace to hold all variables and methods.
var oppiSite = {};

//Initiating Bootstrap Plugins
oppiSite.initBootstrapPlugins = function () {

  var $heroCarouselItems = $('#heroCarousel .carousel-item');
  $heroCarouselItems.first().addClass('active');
  $.each($heroCarouselItems, function (key, heroCarouselItem) {
    if ($heroCarouselItems.length > 1) {
      $('.carousel-indicators').append('<li data-target="#heroCarousel" data-slide-to="' + key + '"></li>');
    }
  });
  var heroCarouselIndications = $('li[data-target="#heroCarousel"]').first().addClass('active');

};

//Initiating Flickity and any other Gallery Plugins
oppiSite.initGalleryPlugins = function () {

  var $primaryVideoGalleryCarouselCells = $('.primaryVideoGallery .carousel-cell');

  var $primaryVideoGalleryFlickity = $('.primaryVideoGalleryFlickity');

  if ($primaryVideoGalleryCarouselCells.length > 1) {
    //Main Page Flickity Gallery
    $primaryVideoGalleryFlickity.flickity({
      // Options For Flickity Plugin
      // cellAlign: 'left',
      cellAlign: 'center',
      // wrapAround: true,
      contain: true,
      groupCells: true,
      autoPlay: 15000,
      //Configuring Arrow Shape To Be Closer to Original Design
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 40,
        x3: 20
      }
    });
  } else if ($primaryVideoGalleryCarouselCells.length === 1) {
    //Main Page Flickity Gallery
    $primaryVideoGalleryFlickity.flickity({
      // Options For Flickity Plugin
      // cellAlign: 'left',
      cellAlign: 'center',
      wrapAround: true,
      //Configuring Arrow Shape To Be Closer to Original Design
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 40,
        x3: 20
      }
    });
  }

  var $flickityPageDots = $('.flickity-page-dots');

  if ($flickityPageDots.find('li').length === 1) {
    $flickityPageDots.addClass('d-none');
  }

  var $primaryVideoGalleryControls = $('.primaryVideoGallery .flickity-prev-next-button');

  var $primaryVideoGalleryGlickityCells = $('.primaryVideoGallery .carousel-cell');

  var primaryVideoGalleryFlickityFirstCell = $primaryVideoGalleryGlickityCells[0];
  var primaryVideoGalleryFlickityLastCell = $primaryVideoGalleryGlickityCells[$primaryVideoGalleryGlickityCells.length - 1];

  $primaryVideoGalleryFlickity.on('settle.flickity', function (event, index) {
    if ($(primaryVideoGalleryFlickityFirstCell).visible()) {
      // console.log('First Cell Visible');
      $previousButton.attr('disabled', 'disabled');
      $nextButton.removeAttr('disabled');
    }
    if ($(primaryVideoGalleryFlickityLastCell).visible()) {
      // console.log('Last Cell Visible');
      $nextButton.attr('disabled', 'disabled');
      $previousButton.removeAttr('disabled');
    }
  });

  var $flickityPageDots = $('.flickity-page-dots');

  if ($flickityPageDots.find('li').length === 1) {
    $flickityPageDots.addClass('d-none');
  }

  //News and Events Flickity Gallery
  $('.featuredNewsAndEventsFlickity').flickity({
    // Options For Flickity Plugin
    cellAlign: 'left',
    wrapAround: true,
    adaptiveHeight: true,
    //Configuring Arrow Shape To Be Closer to Original Design
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 60,
      y2: 40,
      x3: 20
    }
  });

  var createDropdown = function () {
    $('#desktopNavCarousel li.toplevel').addClass('carousel-cell');
    var $reportNavCarouselItems = $('#desktopNavCarousel .carousel-cell');
    var $desktopNavCarouselListItems = $('#desktopNavCarousel li.toplevel');
    var $firstListItem = $desktopNavCarouselListItems[0];
    var reportInnerNavigationPaddingTop = $('.reportInnerNavigation').css('padding-top');
    reportInnerNavigationPaddingTop = parseInt(reportInnerNavigationPaddingTop, 10);
    var headerNavigationOuterHeight = $('.headerNavLogoContainer').outerHeight();

    var checkIfLoadedAndScroll = function () {
      setTimeout(function () {
        if (!$($firstListItem).hasClass('CMSListMenuHighlightedLI')) {
          $('html,body').animate({
            scrollTop: $('#desktopNavCarousel').offset().top - (reportInnerNavigationPaddingTop + headerNavigationOuterHeight)
          }, 1500);
        }
      }, 300);

    }

    $('#desktopNavCarousel').fadeTo('400', 1, function () {
      checkIfLoadedAndScroll();
    });

    var reportNavItemArray = $reportNavCarouselItems.toArray();
    $.each(reportNavItemArray, function (key, reportNavCarouselItem) {
      if ($(this).has('.secondlevel').length) {
        $(this).find('a').first().addClass('dropdown-toggle');
        $(this).find('ul').addClass('dropdown-menu');
        $(this).find('ul li a').addClass('dropdown-item');
      }
    });
  };

  createDropdown();

  //Report Nav Carousel
  var $reportNavCarousel = $('#desktopNavCarousel');
  // Bind Event Listener First
  $reportNavCarousel.on('ready.flickity', function () {
    //console.log('Flickity ready');
  });
  // initialize Flickity
  $reportNavCarousel.flickity({
    // Options For Flickity Plugin
    // cellAlign: 'center',
    cellAlign: 'center',
    prevNextButtons: false,
    pageDots: false,
    contain: true,
    groupCells: true,
    // wrapAround: true,
    imagesLoaded: true,
    // initialIndex: 1
    accessibility: false
    //watchCSS: true
  });

  var flkty = $reportNavCarousel.data('flickity');

  var $previousButton = $('#previousButtonClick').on('click', function (e) {
    e.preventDefault();
    $reportNavCarousel.flickity('previous');
  });

  var $nextButton = $('#nextButtonClick').on('click', function (e) {
    e.preventDefault();
    $reportNavCarousel.flickity('next');
  });

  var $flickityCells = $('.carousel-cell');

  var flickityFirstCell = $flickityCells[0];
  var flickityLastCell = $flickityCells[$flickityCells.length - 1];

  $reportNavCarousel.on('select.flickity', function () {
    // Enable/Disable Previous/Next buttons
    if (!flkty.cells[flkty.selectedIndex - 1]) {
      // On First Cell
      $previousButton.attr('disabled', 'disabled');
    } else if (!flkty.cells[flkty.selectedIndex + 1]) {
      // On Last Cell
      $nextButton.attr('disabled', 'disabled');
    } else {
      $previousButton.removeAttr('disabled');
      $nextButton.removeAttr('disabled');
    }
  });

  $reportNavCarousel.on('settle.flickity', function (event, index) {
    if ($(flickityFirstCell).visible()) {
      $previousButton.attr('disabled', 'disabled');
      $nextButton.removeAttr('disabled');
    }
    if ($(flickityLastCell).visible()) {
      $nextButton.attr('disabled', 'disabled');
      $previousButton.removeAttr('disabled');
    }
  });

  if ($('.reportInnerNavigationContainer').length) {
    var $flickityCells = $('.carousel-cell');

    var flickityFirstCell = $flickityCells[0];
    var flickityLastCell = $flickityCells[$flickityCells.length - 1];

    if ($(flickityLastCell).visible()) {
      $nextButton.attr('disabled', 'disabled');
    }

    $(window).on('resize', function () {

      if ($(flickityFirstCell).visible() && $(flickityLastCell).visible()) {
        $previousButton.attr('disabled', 'disabled');
        $nextButton.attr('disabled', 'disabled');
      } else {
        $previousButton.removeAttr('disabled');
        $nextButton.removeAttr('disabled');
      }
    });
  }

  //Code for Report Nav Carousel Dropdowns

  var $reportNavDropdowns = $('.reportInnerNavigationContainer .dropdown-menu');

  var addDropDown = function () {
    $('.reportInnerNavigationContainer').height('500');
    $reportNavDropdowns.css('visibility', 'hidden');
    $(this).next('.dropdown-menu').css('visibility', 'visible');
    $(this).next('.dropdown-menu').fadeIn().addClass('show');
  }

  var removeDropDown = function () {
    $(this).next('.dropdown-menu').fadeOut('fast').removeClass('show');
    $reportNavDropdowns.removeAttr('style');
    setTimeout(function () {
      restoreReportNavHeight();
    }, 1000);
  }

  $(".toplevel .dropdown-toggle").hoverIntent({
    over: addDropDown,
    out: removeDropDown,
    timeout: 1500
  });

  var restoreReportNavHeight = function () {
    if (!$('.toplevel .dropdown-toggle').next('.dropdown-menu').hasClass('show')) {
      $('.reportInnerNavigationContainer').height('auto');
    }
  }

  //Report Inner Navigation Mobile Nav Set Up

  var $reportInnerNavigationMobileCollapseLink = $('.reportInnerNavigationMobile .reportAccordianLink');
  var linkForTextContent = $(document).find('title').text();
  var trimmedLinkForTextContent = linkForTextContent.replace("OPPI | ", "");

  $reportInnerNavigationMobileCollapseLink.html(trimmedLinkForTextContent + '<i class="icon-down-open-1" aria-hidden="true"></i>');
  $('.reportAccordianLink').fadeTo('400', 1);

  $('.infographicSlider').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 55,
      y2: 40,
      x3: 15
    }
  });
}

//Creating Google Charts for OPPI Site
oppiSite.initGoogleCharts = function () {

  if ($('#piechart_3d').length > 0) {
    google.charts.load("current", {
      packages: ["corechart"]
    });
    google.charts.setOnLoadCallback(drawChart1);
    google.charts.setOnLoadCallback(drawChart2);

    function drawChart1() {
      var dataTable = new google.visualization.DataTable();
      dataTable.addColumn('string', 'Sector');
      dataTable.addColumn('number', 'Amount');
      dataTable.addColumn({
        type: 'string',
        role: 'tooltip'
      });
      dataTable.addRows([
        ['Membership Fee, 58%', 13.91, 'Membership Fee Revenue: $1,402,630'],
        ['Conference, 24%', 5.75, 'Conference Revenue: $586,854'],
        ['Journal & Mailings, 8%', 1.92, 'Journal & Mailings Revenue: $190,261'],
        ['Professional Development, 4%', .97, 'Professional Development Revenue: $96,315'],
        ['Other, 6%', 1.45, 'Other Revenue: $152,897']
      ]);


      var options = {
        titleTextStyle: {
          color: '#0060ac',
          fontName: 'Arial',
          fontSize: 28,
          bold: true,
          italic: false
        },
        title: 'Revenue',
        //width: 750,
        height: 600,
        is3D: true,
        chartArea: {
          width: "100%",
          left: 0
        },
        pieStartAngle: 0,
        pieSliceTextStyle: {
          fontSize: 13
        },
        backgroundColor: {
          fill: 'transparent'
        },
        colors: ['#4c99c7', '#edc130', '#81b044', '#e5773d', '#084d86'],
        fontName: 'Arial',
        pieStartAngle: 15,
        fontSize: 14,
        tooltipTextStyle: {
          fontName: 'Arial',
          fontSize: 14,
        },
      };

      var chart = new google.visualization.PieChart(document.getElementById('piechart_3d'));
      chart.draw(dataTable, options);
      $(window).resize(function () {
        options.width = 0;
        chart.draw(dataTable, options);
      });
    }

    function drawChart2() {
      var dataTable = new google.visualization.DataTable();
      dataTable.addColumn('string', 'Sector');
      dataTable.addColumn('number', 'Amount');
      dataTable.addColumn({
        type: 'string',
        role: 'tooltip'
      });
      dataTable.addRows([
        ['Administration, 26%', 9.95, 'Administration Expenses: $ 596,250'],
        ['Conference & PKE, 26%', 9.95,
          'Conference & Planning Knowledge Exchange Expenses: $ 594,421'
        ],
        ['Strategy Groups & DLT, 20% ', 7.65,
          'Strategy Groups & District Leadership Teams Expenses: $461,985'
        ],
        ['Communications, Marketing & Recognition, 14%', 5.35,
          'Communications, Marketing & Recognition Expenses: $325,008'
        ],
        ['Governance & Nominating, 8%', 3.08, 'Governance & Nominating Expenses: $172,417'],
        ['Discipline, 6%', 2.30,
          'Discipline, Professional Standards & Government Relations Expenses: $126,438'
        ]
      ]);


      var options = {
        titleTextStyle: {
          color: '#0060ac',
          fontName: 'Arial',
          fontSize: 28,
          bold: true,
          italic: false
        },
        title: 'Expense',
        //width: 750,
        height: 600,
        is3D: true,
        chartArea: {
          width: "100%",
          left: 0
        },
        pieStartAngle: 0,
        pieSliceTextStyle: {
          fontSize: 13
        },
        backgroundColor: {
          fill: 'transparent'
        },
        colors: ['#4c99c7', '#edc130', '#81b044', '#e5773d', '#084d86', '#D7E0E1'],
        fontName: 'Arial',
        fontSize: 14,
        tooltipTextStyle: {
          fontName: 'Arial',
          fontSize: 14,
        },
      };

      var chart = new google.visualization.PieChart(document.getElementById('piechart_3d2'));
      chart.draw(dataTable, options);
      $(window).resize(function () {
        options.width = 0;
        chart.draw(dataTable, options);
      });
    }
  }
}

//Code for all User Events on OPPI Site
oppiSite.userEvents = function () {

  //Setting Language of HTML
  document.getElementsByTagName('html')[0].setAttribute('lang', 'en-us');

  //Setting Active Class of Top Level Links on Desktop

  var setActiveStateOfHeadingLinks = function () {
    if (window.location.href.indexOf("inspiring-knowledge") > -1) {
      //  console.log("Inspiring Knowledge");
      $('#navbarDropdownOne').addClass('active');
    } else if (window.location.href.indexOf("news") > -1) {
      // console.log("News");
      $('#navbarDropdownTwo').addClass('active');
    } else if (window.location.href.indexOf("hire-an-rpp") > -1) {
      // console.log("Hire An RPP");
      $('#navbarDropdownThree').addClass('active');
    } else if (window.location.href.indexOf("become-an-rpp") > -1) {
      // console.log("Become An RPP");
      $('#navbarDropdownFour').addClass('active');
    } else if (window.location.pathname.indexOf("oppi") > -1) {
      // console.log("OPPI");
      $('#navbarDropdownFive').addClass('active');
    }
  }

  setActiveStateOfHeadingLinks();

  if ($('.caseStudiesPageMediaGallery').length) {
    var $caseStudyCards = $('.caseStudiesPageMediaGallery').find('.card');
    if ($caseStudyCards.length === 1) {
      $('.caseStudiesPageMediaGallery').find('.d-flex').addClass('justify-content-start');
    }
  }

  //New code for Header Navigation Hover Intent

  $('.headerNavText .nav-link').focus(function () {
    $(this).next('.dropdown-menu').css('display', '');
  });

  var addDropDown = function () {
    $(this).find('.dropdown-menu').fadeIn().addClass('show');
  }

  var removeDropDown = function () {
    $(this).find('.dropdown-menu').fadeOut().removeClass('show');
  }

  $(".headerNavText .nav-item.dropdown").hoverIntent({
    over: addDropDown,
    out: removeDropDown,
    timeout: 500
  });

  $('.headerNavSearchButton').on('click', function (e) {
    e.preventDefault();
    $('#headerNavSearchInput').fadeToggle();
    $('#headerNavSearchTextInput').focus();
  });

  $('#headerSearchSubmit').on('click', function (e) {
    e.preventDefault();
    var headerSearchQuery = $('#headerNavSearchTextInput').val();
    window.location = "/search-results?searchtext=" + headerSearchQuery + "&searchmode=anyword";
  });

  $('#headerNavSearchTextInput').keypress(function (e) {
    if (e.which == 13) {
      var headerSearchQuery = $(this).val();
      window.location = "/search-results?searchtext=" + headerSearchQuery + "&searchmode=anyword";
    }
  });

  //Mobile Nav Hamburger Menu Toggling

  $('#headerHamburgerMenu').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('open');
    $('body').toggleClass('fixedPosition');
    if (!$('#headerHamburgerMenu').hasClass('open')) {
      $('.subNav').removeClass('show');
      $('.bottomNav').removeClass('show');
      $('.expandIcon').removeClass('open');
    }
  });

  $('#headerHamburgerMenu').on('click', function () {
    $('#mobileNavigation').slideToggle('fast');
  });

  $('.nav-link').on('click', function () {
    $(this).next('.expandIcon').toggleClass('open');
  });

  $('.expandIcon').on('click', function () {
    $(this).prev('.nav-link').click();
  });

  //Accordian Button Click

  $('.card-header button').on('click', function (e) {
    e.preventDefault();
  });

  $('.collapse').on('show.bs.collapse', function () {
    var i = $(this).parent().find('i')
    i.toggleClass('icon-plus-1 icon-minus');
  }).on('hide.bs.collapse', function () {
    var i = $(this).parent().find('i')
    i.toggleClass('icon-minus icon-plus-1');
  });

  //Home Page Video Lightbox Modals

  $('.primaryVideoGalleryPlayButton').on('click', function (e) {
    e.preventDefault();
  });

  var loadPrimaryVideoGalleryModals = function () {
    var $primaryVideoGalleryCarouselCells = $('.primaryVideoGalleryFlickity .carousel-cell');
    var $primaryVideoGalleryModalContainer = $('.primaryVideoGalleryModalContainer');
    var $primaryVideoGalleryModal = $('.primaryVideoGalleryModalContainer .modal');
    var originalModalId = $primaryVideoGalleryModal.attr('id');
    $.each($primaryVideoGalleryCarouselCells, function (key, primaryVideoGalleryCarouselCell) {
      var $carouselCellPlayButton = $(primaryVideoGalleryCarouselCell).find('.primaryVideoGalleryPlayButton');
      var $carouselCellImageDataSrc = $carouselCellPlayButton.attr('data-video-src');
      $primaryVideoGalleryModal.clone().appendTo($primaryVideoGalleryModalContainer);
      $primaryVideoGalleryModal.attr('id', originalModalId + key);
      $primaryVideoGalleryModalIframe = $primaryVideoGalleryModal.find('iframe');
      $primaryVideoGalleryModalIframe.attr('src', $carouselCellImageDataSrc);
      $carouselCellPlayButton.attr('data-target', '#' + $primaryVideoGalleryModal.attr('id'));
    });
    $('.modal').on('hide.bs.modal', function () {
      var iframeSrc = $(this).find('iframe').attr("src");
      $(this).find('iframe').attr("src", iframeSrc);
    });
    $('#primaryVideoModal').remove();
  }
  loadPrimaryVideoGalleryModals();

  var $primaryVideoGalleryContainer = $('.primaryVideoGalleryContainer');


  setTimeout(function () {
    $primaryVideoGalleryContainer.fadeTo('400', 1)
    $('.loader').fadeOut('fast');
  }, 500);

  //Additional Video Gallery Modals

  var loadAdditionalVideoGalleryModals = function () {
    var $additionalVideoGalleryPreviewCards = $('.additionalVideoGallery .card');
    var $additionalVideoGalleryModalContainer = $('.additionalVideoGalleryModalContainer');
    var $additionalVideoGalleryModal = $('.additionalVideoGalleryModalContainer .modal');
    var originalModalId = $additionalVideoGalleryModal.attr('id');
    $.each($additionalVideoGalleryPreviewCards, function (key, additionalVideoGalleryPreviewCard) {
      var $previewCardPlayButton = $(additionalVideoGalleryPreviewCard).find('.primaryVideoGalleryPlayButton');
      var $previewCardImageDataSrc = $previewCardPlayButton.attr('data-video-src');
      $additionalVideoGalleryModal.clone().appendTo($additionalVideoGalleryModalContainer);
      $additionalVideoGalleryModal.attr('id', originalModalId + key);
      $additionalVideoGalleryModalIframe = $additionalVideoGalleryModal.find('iframe');
      $additionalVideoGalleryModalIframe.attr('src', $previewCardImageDataSrc);
      $previewCardPlayButton.attr('data-target', '#' + $additionalVideoGalleryModal.attr('id'));
    });
    $('.modal').on('hide.bs.modal', function () {
      var iframeSrc = $(this).find('iframe').attr("src");
      $(this).find('iframe').attr("src", iframeSrc);
    });
    $('#primaryVideoModal').remove();
  }
  loadAdditionalVideoGalleryModals();

  //Calls to Action Video Gallery Modals

  var loadCallsToActionVideoGalleryModals = function () {
    var $additionalVideoGalleryPreviewCards = $('.callsToActionLandingPageMediaGallery .card');
    var $additionalVideoGalleryModalContainer = $('.additionalVideoGalleryModalContainer');
    var $additionalVideoGalleryModal = $('.additionalVideoGalleryModalContainer .modal');
    var originalModalId = $additionalVideoGalleryModal.attr('id');
    $.each($additionalVideoGalleryPreviewCards, function (key, additionalVideoGalleryPreviewCard) {
      var $previewCardPlayButton = $(additionalVideoGalleryPreviewCard).find('.primaryVideoGalleryPlayButton');
      var $previewCardImageDataSrc = $previewCardPlayButton.attr('data-video-src');
      $additionalVideoGalleryModal.clone().appendTo($additionalVideoGalleryModalContainer);
      $additionalVideoGalleryModal.attr('id', originalModalId + key);
      $additionalVideoGalleryModalIframe = $additionalVideoGalleryModal.find('iframe');
      $additionalVideoGalleryModalIframe.attr('src', $previewCardImageDataSrc);
      $previewCardPlayButton.attr('data-target', '#' + $additionalVideoGalleryModal.attr('id'));
    });
    $('.modal').on('hide.bs.modal', function () {
      var iframeSrc = $(this).find('iframe').attr("src");
      $(this).find('iframe').attr("src", iframeSrc);
    });
    $('#primaryVideoModal').remove();
  }
  loadCallsToActionVideoGalleryModals();

  //Landing Page Events

  $('#primaryAccordion .btn').on('click', function () {
    if ($(this).prev('.accordionExpandIcon').hasClass('open')) {
      $(this).prev('.accordionExpandIcon').removeClass('open');
    } else {
      $(this).prev('.accordionExpandIcon').addClass('open');
    }
  });

  //Accordian Expand Animations

  $('.accordionExpandIcon').on('click', function () {
    $(this).toggleClass('open');
    $(this).next('.btn').click();
  });

  //Blog Template Page Events

  //Code Snippet for Preventing Accordian Collapse Closing Dropdown Menu By Default. 

  $(document).on(
    'click.bs.dropdown.data-api',
    '[data-toggle="collapse"]',
    function (e) {
      e.stopPropagation()
    }
  );

  //Blog Filter Search Input

  $('#blogFilterSearchButton').on('click', function (e) {
    e.preventDefault();
    $('#blogFilterSearchInput').fadeToggle();
    $('#blogSearchQuery').focus();
  });

  $('#blogSearchSubmit').on('click', function (e) {
    e.preventDefault();
    var blogSearchQuery = $('#blogSearchQuery').val();
    window.location = "/blog/planning-exchange/search-results?searchtext=" + blogSearchQuery + "&searchmode=anyword";
  });

  $('#blogSearchQuery').keypress(function (e) {
    if (e.which == 13) {
      var blogSearchQuery = $(this).val();
      window.location = "/blog/planning-exchange/search-results?searchtext=" + blogSearchQuery + "&searchmode=anyword";
    }
  });

  $('.primaryBlog #blogFilterSearchButton').html('<span class="sr-only">Blog Filter Search Button</span><i id="blogSearchIcon" class="icon-search-1" aria-hidden="true"></i>');


  //Blog Preview Card Elements

  var $blogPreviewFlexContainer = $('.blogPreviewFlexContainer');
  var $blogPreviewCards = $('.blogPreviewCard');
  var selectedTopic = '';
  var $filteredBlogPreviews = [];

  //Filter Blog Posts By Date Newest to Oldest

  $('#filterBlogPostsByDate').on('click', function () {
    $blogPreviewCards.sort(function (a, b) {
      var aDataDate = a.getAttribute('data-date')
      var bDataDate = b.getAttribute('data-date');
      var aDataDateConverted = moment(aDataDate, "M/D/YYYY").format('YYYY/MM/DD');
      var bDataDateConverted = moment(bDataDate, "M/D/YYYY").format('YYYY/MM/DD');

      if (aDataDateConverted < bDataDateConverted) {
        return 1;
      }
      if (aDataDateConverted > bDataDateConverted) {
        return -1;
      }
      return 0;
    });

    $blogPreviewCards.detach().prependTo($blogPreviewFlexContainer);
    oppiSite.lazyLoadImages();
  });

  //Filter Blog Posts Alphabetically By Title

  $('#filterBlogPostsAlphabetical').on('click', function () {
    $blogPreviewCards.sort(function (a, b) {
      var aDataTitle = a.getAttribute('data-title')
      var bDataTitle = b.getAttribute('data-title');
      if (aDataTitle > bDataTitle) {
        return 1;
      }
      if (aDataTitle < bDataTitle) {
        return -1;
      }
      return 0;
    });

    $blogPreviewCards.detach().prependTo($blogPreviewFlexContainer);
    oppiSite.lazyLoadImages();
  });

  $('.primaryBlogFilter .dropdown-toggle').on('click', function () {
    selectedTopic = '';
    $filteredBlogPreviews = [];
    $blogPreviewCards.prependTo($blogPreviewFlexContainer);
  });

  //Creating Filter Tags in Dropdown Menu with Items Provided by Kentico

  var $tagCloudItems = $('.blogTagCloud span a');

  var $blogFilterDropDownItem = $('.primaryBlogFilter .dropdown-item');

  $.each($tagCloudItems, function (key, tagCloudItem) {
    var tagCloadHref = $(tagCloudItem).attr('href');
    var tagCloudText = $(tagCloudItem).text();
    $($blogFilterDropDownItem[key]).attr('href', tagCloadHref);
    $($blogFilterDropDownItem[key]).text(tagCloudText);
  });

  //Grabbing Hidden Filter Tag Value to Display in Blog Filter when Filter Topic is Selected

  var $hiddenFilterTag = $('.hiddenFilterTag p').text();


  if ($hiddenFilterTag != '') {
    $('.primaryBlogFilter .dropdown-toggle').addClass('d-none');
    $('.primaryBlogFilter .filterCriteriaButton').removeClass('d-none').html($hiddenFilterTag + '<i class="icon-cancel-1" aria-hidden="true"></i>');
  }

  //Resetting Filter Criteria

  $('.primaryBlogFilter .filterCriteriaButton').on('click', function (e) {
    e.preventDefault();
    $(this).addClass('d-none');
    selectedTopic = '';
    $filteredBlogPreviews = [];
    $blogPreviewCards.prependTo($blogPreviewFlexContainer);
    $('.primaryBlogFilter .dropdown-toggle').removeClass('d-none');
    window.location = "/blog/planning-exchange/";
  });

  $('.blogPreviewFlexContainer').fadeTo('400', 1);

  //Dynamically Create Filter Months from Info Given By Kentico

  var $blogFilterMonths = $('.blogFilterMonths a');
  var originalBlogFilterYears = [];
  $.each($blogFilterMonths, function (key, blogFilterMonth) {
    var blogFilterMonthText = $(this).text();
    var blogFilterMonthMoment = moment(blogFilterMonthText, "MMMM/DD/YYYY").year();
    originalBlogFilterYears.push(blogFilterMonthMoment);
  });
  var uniqueBlogFilterYears = [];
  $.each(originalBlogFilterYears, function (key, originalBlogFilterYear) {
    if ($.inArray(originalBlogFilterYear, uniqueBlogFilterYears) === -1) uniqueBlogFilterYears.push(originalBlogFilterYear);
  });

  function sortBlogFilterYears(a, b) {
    return b - a;
  }
  uniqueBlogFilterYears.sort(sortBlogFilterYears);
  var blogFilterYearsToUse = {};
  $.each(uniqueBlogFilterYears, function (key, uniqueBlogFilterYear) {
    blogFilterYearsToUse[uniqueBlogFilterYear] = [];
  });
  $.each($blogFilterMonths, function (key, blogFilterMonth) {
    var blogFilterMonthText = $(this).text();
    var blogFilterMonthMoment = moment(blogFilterMonthText, "MMMM/DD/YYYY").year();
    if ($.inArray(blogFilterMonthMoment, uniqueBlogFilterYears) !== -1) {
      blogFilterYearsToUse[blogFilterMonthMoment].push($(this));
    }
  });


  var setupBlogFilterByYear = function (uniqueBlogFilterYears) {
    var $blogFilterAccordian = $('#blogFilterAccordion');
    $.each(uniqueBlogFilterYears, function (index, year) {
      $blogFilterAccordian.append('<div class="card"><div class="card-header"><h5><a class="blogFilterYearLink">' + year + '</a></h5></div></div>')
    });
  };

  setupBlogFilterByYear(uniqueBlogFilterYears);

  $('.blogFilterYearLink').on('click', function (e) {
    e.preventDefault
    var currentSelectedYear = $(this).text();
    $('.primaryBlogFilter .dropdown-toggle').addClass('d-none');
    $('.primaryBlogFilter .filterCriteriaButton').removeClass('d-none').html(currentSelectedYear + '<i class="icon-cancel-1" aria-hidden="true"></i>');
    var $blogPreviewCardsToBeFiltered = $('.blogPreviewCard');
    $.each($blogPreviewCardsToBeFiltered, function (index, BlogPreviewCard) {
      var blogPreviewCardYear = $(BlogPreviewCard).attr('data-date');
      var convertedBlogPreviewCardYear = moment(blogPreviewCardYear, "MMMM/DD/YYYY").format("YYYY");
      if (convertedBlogPreviewCardYear === currentSelectedYear) {
        $(BlogPreviewCard).show();
      } else {
        $(BlogPreviewCard).hide();
      }
    });
    $('.blogPreviewCardImage').each(function () {
      var $cardImg = $(this);
      if (isInViewPort($cardImg)) {
        $cardImg.attr("src", $cardImg.data("src"));
      }
    });

    function isInViewPort($element) {
      var rect = $element[0].getBoundingClientRect();
      var viewport = document.documentElement;
      return (rect.top >= 0 && (rect.bottom - 350) <= (window.innerHeight || viewport.clientHeight));
    }
  });

  var $blogFilterAccordian = $('#blogFilterAccordion');
  var $blogFilterAccordianCard = $('#blogFilterAccordion .card');
  var $blogFilterAccordianCardButton = $blogFilterAccordianCard.find('.btn');
  var originalButtonDataTarget = $blogFilterAccordianCardButton.attr('data-target');
  var $blogFilterAccordianCardCollapse = $blogFilterAccordianCard.find('.collapse');
  var originalCollapseId = $blogFilterAccordianCardCollapse.attr('id');
  var $blogFilterAccordianCardListGroupLink = $blogFilterAccordianCard.find('.list-group a');

  var loadBlogFilterAccordianCards = function () {

    $.each(blogFilterYearsToUse, function (key, value) {
      $blogFilterAccordianCardButton.html(key);
      $blogFilterAccordianCardButton.attr('data-target', originalButtonDataTarget + key);
      $blogFilterAccordianCardCollapse.attr('id', originalCollapseId + key);
      var elementKey = key;
      $blogFilterAccordianCard.clone().prependTo($blogFilterAccordian);
    });
    $blogFilterAccordianCard.remove();
    createListGroupItems();
  }

  var createListGroupItems = function () {
    var $blogFilterAccordianCard = $('#blogFilterAccordion .card');

    $.each($blogFilterAccordianCard, function (key, value) {
      var $blogFilterAccordianCardButtonText = $(this).find('.btn').text();
      var $blogFilterAccordianCardListGroup = $(this).find('.list-group');
      var $blogFilterAccordianCardListGroupLink = $(this).find('.list-group a');
      var currentYearsArray = blogFilterYearsToUse[$blogFilterAccordianCardButtonText];
      var currentYearContainingArray = [];

      for (var i = 0; i < currentYearsArray.length; i++) {
        var clonedLink = $blogFilterAccordianCardListGroupLink.clone();
        clonedLink.attr('href', currentYearsArray[i].attr('href'));
        var clonedLinkText = currentYearsArray[i].text();
        var convertedClonedLinkText = moment(clonedLinkText, "MMMM/DD/YYYY").format("MMMM");
        clonedLink.text(convertedClonedLinkText);
        currentYearContainingArray.push(clonedLink);
      }
      $blogFilterAccordianCardListGroupLink.detach();

      for (var i = 0; i < currentYearContainingArray.length; i++) {
        $blogFilterAccordianCardListGroup.prepend(currentYearContainingArray[i])
      }
    });

  }

  // loadBlogFilterAccordianCards();


  //Scroll Up Functionality for Primary Blog Template

  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= ($(document).height() - $(window).height()) * 0.25 && $(window).scrollTop() && $(window).scrollTop() <= (($('main').height()) - ($('footer').height()))) {
      $('a.scrollUp').fadeIn();
    } else if ($(window).scrollTop() <= ($(document).height() - $(window).height()) * 0.25) {
      $('a.scrollUp').fadeOut();
    } else if ($(window).scrollTop() >= (($('main').height()) - ($('footer').height()))) {
      $('a.scrollUp').fadeOut();
    }

  });

  //Smooth Scroll For Blog Scroll to Top Link

  $('a.scrollUp[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: 1
        }, 1000);
        return false;
      }
    }
  });

  //Blog Article Functionality 

  //Print Button For Blog Article 

  $('#primaryBlogArticlePrintLink').on('click', function () {
    window.print();
  });

  //News and Events Events

  var $eventPreviewCards = $('.eventPreviewCard');

  $.each($eventPreviewCards, function (key, eventPreviewCard) {
    var eventPreviewThumbnailImg = $(eventPreviewCard).find('.eventPreviewThumbnail').find('img');
    var originalDataTargetAttr = eventPreviewThumbnailImg.attr('data-target');
    eventPreviewThumbnailImg.attr('data-target', originalDataTargetAttr + key);
    var linkedModalElement = $(eventPreviewCard).find('.modal');
    var originalLinkedModalElementId = linkedModalElement.attr('id');
    linkedModalElement.attr('id', originalLinkedModalElementId + key);

    //Code Below Needed if Only Wanting to Upload Image in One Place - The Thumbnail Source

    var eventPreviewThumbnailSrc = eventPreviewThumbnailImg.attr('src');
    linkedModalElement.find('img').attr('src', eventPreviewThumbnailSrc);
  });

  $('.primaryEventsSearch .dropdown-item').on('click', function (e) {
    e.preventDefault();
    $('.primaryEventsSearch .dropdown').find('button').html($(this).text() + '<i class="icon-down-open-1" aria-hidden="true"></i>');
  });

  $('.eventPreviewThumbnailImageOverlay').on('click', function () {});

  //Events Events

  var $eventPreviewImages = $('.eventPreviewImage');

  $.each($eventPreviewImages, function (key, eventPreviewImage) {
    var eventPreviewThumbnailImg = $(eventPreviewImage).find('.eventPreviewThumbnail').find('img');
    var eventPreviewEnlargeLink = $(eventPreviewImage).find('.eventPreviewThumbnail').find('a');
    var originalDataTargetAttr = eventPreviewEnlargeLink.attr('data-target');
    eventPreviewEnlargeLink.attr('data-target', originalDataTargetAttr + key);
    var linkedModalElement = $(eventPreviewImage).find('.modal');
    var originalLinkedModalElementId = linkedModalElement.attr('id');
    linkedModalElement.attr('id', originalLinkedModalElementId + key);

    //Code Below Needed if Only Wanting to Upload Image in One Place - The Thumbnail Source

    var eventPreviewThumbnailSrc = eventPreviewThumbnailImg.attr('src');
    linkedModalElement.find('img').attr('src', eventPreviewThumbnailSrc);
  });

  //Print Button For Event Item

  $('#primaryEventPrintLink').on('click', function () {
    window.print();
  });

  //Spotlight Events

  //Setting first person in Spotlight List as Featured Spotlight Item

  var $spotlightListItem = $('.spotlightListItem');
  var $featuredSpotlight = $('.featuredSpotlight');

  var selectedSpotlightImage = $($spotlightListItem[0]).find('img').attr('data-src');
  var selectedSpotlightHeading = $($spotlightListItem[0]).find('.spotlightListItemHeading').text();
  var selectedSpotlightTitle = $($spotlightListItem[0]).find('.spotlightListItemTitle').text();
  var selectedSpotlightLocation = $($spotlightListItem[0]).find('.spotlightListItemLocation').text();
  var selectedSpotlightMailTo = $($spotlightListItem[0]).find('.spotlightListItemMailTo');
  var selectedSpotlightPhoneLink = $($spotlightListItem[0]).find('.spotlightListItemPhoneLink');
  var selectedSpotlightDescription = $($spotlightListItem[0]).attr('data-description');

  //Replacing Featured Spotlight with Spotlight That is Clicked On

  $featuredSpotlight.find('.featuredSpotlightHeading').text(selectedSpotlightHeading);
  $featuredSpotlight.find('img').attr('src', selectedSpotlightImage);
  $featuredSpotlight.find('a').text(selectedSpotlightHeading);
  $featuredSpotlight.find('.featuredSpotLightMailTo').attr('href', selectedSpotlightMailTo.attr('href')).text(selectedSpotlightMailTo.text());
  // $featuredSpotlight.find('.featuredSpotlightMailToName').attr('href', selectedSpotlightMailTo.attr('href')).text(selectedSpotlightHeading);
  $featuredSpotlight.find('.featuredSpotlightYellowText').text(selectedSpotlightHeading);
  $featuredSpotlight.find('.featuredSpotLightPhoneLink').attr('href', selectedSpotlightPhoneLink.attr('href')).text(selectedSpotlightPhoneLink.text());
  $featuredSpotlight.find('.featuredSpotLightTitle').text(selectedSpotlightTitle);
  $featuredSpotlight.find('.featuredSpotLightLocation').html(selectedSpotlightLocation);
  $featuredSpotlight.find('.featuredSpotLightDescription').html(selectedSpotlightDescription);

  $spotlightListItem.on('click', function () {
    var selectedSpotlightImage = $(this).find('img').attr('data-src');
    var selectedSpotlightHeading = $(this).find('.spotlightListItemHeading').text();
    var selectedSpotlightTitle = $(this).find('.spotlightListItemTitle').text();
    var selectedSpotlightLocation = $(this).find('.spotlightListItemLocation').text();
    var selectedSpotlightMailTo = $(this).find('.spotlightListItemMailTo');
    var selectedSpotlightPhoneLink = $(this).find('.spotlightListItemPhoneLink');
    var selectedSpotlightDescription = $(this).attr('data-description');
    $featuredSpotlight.find('.featuredSpotlightHeading').text(selectedSpotlightHeading);
    $featuredSpotlight.find('img').attr('src', selectedSpotlightImage);
    $featuredSpotlight.find('a').text(selectedSpotlightHeading);
    $featuredSpotlight.find('.featuredSpotLightMailTo').attr('href', selectedSpotlightMailTo.attr('href')).text(selectedSpotlightMailTo.text());
    $featuredSpotlight.find('.featuredSpotlightMailToName').attr('href', selectedSpotlightMailTo.attr('href')).text(selectedSpotlightHeading);
    $featuredSpotlight.find('.featuredSpotLightPhoneLink').attr('href', selectedSpotlightPhoneLink.attr('href')).text(selectedSpotlightPhoneLink.text());
    $featuredSpotlight.find('.featuredSpotLightTitle').text(selectedSpotlightTitle);
    $featuredSpotlight.find('.featuredSpotLightLocation').html(selectedSpotlightLocation);
    $featuredSpotlight.find('.featuredSpotLightDescription').html(selectedSpotlightDescription);
    $featuredSpotlight.find('.featuredSpotlightYellowText').text(selectedSpotlightHeading);
  });

  var createSpotlightGalleryAndOverlay = function () {

    setTimeout(function () {
      $('.spotlightPreviewRelativeContainer').fadeTo('400', 1)
      $('.loader').fadeOut('fast');
    }, 500);

    $('.spotlightPreviewListContainer').on('mouseover', function () {
      $(this).fadeOut();
    });

    setTimeout(function () {
      $('.spotlightPreviewListContainer').fadeOut();
    }, 5000);

    var $spotlightPreviewListItem = $('.spotlightPreviewListItem');

    var $spotlightPreviewListRow = $('.spotlightPreviewListRow');

    var $featuredSpotlightScrollLinks = $('.spotlightListItem');

    var $spotlightGalleryFlickity = $('.spotlightGalleryFlickity');

    var $originalSpotlightCarouselCell = $('.featuredSpotlight.carousel-cell');

    $originalSpotlightCarouselCell.detach();

    $.each($featuredSpotlightScrollLinks, function (index, featuredSpotlightScrollLink) { 

      $(featuredSpotlightScrollLink).attr('data-index', index);
   
      var selectedSpotlightImage = $(featuredSpotlightScrollLink).find('img').attr('data-src');
      var selectedSpotlightHeading = $(featuredSpotlightScrollLink).find('.spotlightListItemHeading').text();
      var selectedSpotlightTitle = $(featuredSpotlightScrollLink).find('.spotlightListItemTitle').text();
      var selectedSpotlightLocation = $(featuredSpotlightScrollLink).find('.spotlightListItemLocation').text();
      var selectedSpotlightMailTo = $(featuredSpotlightScrollLink).find('.spotlightListItemMailTo');
      var selectedSpotlightPhoneLink = $(featuredSpotlightScrollLink).find('.spotlightListItemPhoneLink');
      var selectedSpotlightDescription = $(featuredSpotlightScrollLink).attr('data-description');

      $spotlightPreviewListItem.find('p').text(selectedSpotlightHeading);

      $spotlightPreviewListItem.clone().appendTo($spotlightPreviewListRow);

      $originalSpotlightCarouselCell.find('.featuredSpotlightHeading').text(selectedSpotlightHeading);
      $originalSpotlightCarouselCell.find('img').attr('src', selectedSpotlightImage);
      $originalSpotlightCarouselCell.find('a').text(selectedSpotlightHeading);
      $originalSpotlightCarouselCell.find('.featuredSpotLightMailTo').attr('href', selectedSpotlightMailTo.attr('href')).text(selectedSpotlightMailTo.text());
      $originalSpotlightCarouselCell.find('.featuredSpotlightMailToName').attr('href', selectedSpotlightMailTo.attr('href')).text(selectedSpotlightHeading);
      $originalSpotlightCarouselCell.find('.featuredSpotLightPhoneLink').attr('href', selectedSpotlightPhoneLink.attr('href')).text(selectedSpotlightPhoneLink.text());
      $originalSpotlightCarouselCell.find('.featuredSpotLightTitle').text(selectedSpotlightTitle);
      $originalSpotlightCarouselCell.find('.featuredSpotLightLocation').html(selectedSpotlightLocation);
      $originalSpotlightCarouselCell.find('.featuredSpotLightDescription').html(selectedSpotlightDescription);
      $originalSpotlightCarouselCell.find('.featuredSpotlightYellowText').text(selectedSpotlightHeading);
      
      $originalSpotlightCarouselCell.clone().appendTo($spotlightGalleryFlickity);
      
    });   

    // initialFeaturedSpotlight.remove();

    $spotlightPreviewListItem.detach();

    $spotlightGalleryFlickity.flickity({
      // Options For Flickity Plugin
      cellAlign: 'center',
      pageDots: false,
      wrapAround: true,
      contain: true,
      groupCells: true,
      adaptiveHeight: true,
      //Configuring Arrow Shape To Be Closer to Original Design
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 55,
        y2: 40,
        x3: 15
      }
    }); 
    
    $spotlightGalleryFlickity.on( 'change.flickity', function( event, index ) {
      // console.log( 'Slide changed to ' + index )
      var spotlightSlideIndex = index;
      $featuredSpotlightScrollLinks.parent().removeClass('activeSpotlightItem');
      $.each($featuredSpotlightScrollLinks, function (index, featuredSpotLightScrollLink) { 
        // console.log($(featuredSpotLightScrollLink).attr('data-index'));
        var featuredSpotLightScrollLinkDataIndex = $(featuredSpotLightScrollLink).attr('data-index');
        var featuredSpotIndexNumber = parseInt(featuredSpotLightScrollLinkDataIndex);
        // console.log(spotlightSlideIndex);
        // console.log(typeof featuredSpotLightScrollLinkDataIndex);
         if(featuredSpotIndexNumber === spotlightSlideIndex) {
          //  console.log('Yes');
           $(featuredSpotLightScrollLink).parent().addClass('activeSpotlightItem');
         }
      });

    });

    $featuredSpotlightScrollLinks.on('click', function () {
      var selectedIndex = $(this).attr('data-index');
      $spotlightGalleryFlickity.flickity( 'select', selectedIndex);
    });
    

  };

  createSpotlightGalleryAndOverlay();

  //Scrolling to Featured Spotlight Section on Click

  if ($('.featuredSpotlightScrollLink').length) {
    $('.featuredSpotlightScrollLink').first().addClass('activeSpotlightItem');
  }

  $('.spotlightListItemHeading').mouseenter(function () {
    $(this).prev().css("border-color", "#969696");
  });
  $('.spotlightListItemHeading').mouseleave(function () {
    $(this).prev().removeAttr("style");
  });

  $('.featuredSpotlightScrollLink').on('click', function () {
    $('.featuredSpotlightScrollLink').removeClass('activeSpotlightItem');
    $(this).addClass('activeSpotlightItem');
    var featuredSpotlightPaddingTop = $('.featuredSpotlightContainer').css('padding-top');
    featuredSpotlightPaddingTop = parseInt(featuredSpotlightPaddingTop, 10);
    var featuredSpotlightHeadingHeight = $('.featuredSpotlightHeading').outerHeight();
    $('html,body').animate({
      scrollTop: $('#featuredSpotlight').offset().top - (featuredSpotlightPaddingTop + featuredSpotlightHeadingHeight)
    }, 1000);

  });

  //Membership Applications Dropdown Functionality

  $('#membershipApplicationsDropdownMenu').fadeTo('400', 1);

  var $membershipApplicationDropdown = $('.membershipApplicationsDropdown #dropdownMenuButton');

  $membershipApplicationDropdown.html("I'm a..." + '<i class="icon-down-open-1" aria-hidden="true"></i>');

  $membershipApplicationDropdown.on('click', function (e) {
    e.preventDefault();
    var originalDropdownText = $(this).html();
    $('.membershipApplicationOption').fadeOut('fast');
    $(this).html("I'm a..." + '<i class="icon-down-open-1" aria-hidden="true"></i>');
  });

  $membershipApplicationDropdown.next('.dropdown-menu').find('.dropdown-item').on('click', function (e) {
    e.preventDefault();
    var selectedCategory = $(this).text().toString().toLowerCase();
    $membershipApplicationDropdown.html("I'm a " + selectedCategory + '<i class="icon-down-open-1" aria-hidden="true"></i>');
    var selectedMembershipCategoryId = $(this).attr('href');
    $('.membershipApplicationsDropdown').find(selectedMembershipCategoryId).fadeIn();
  });

  $('#membershipApplicationsDropdownMenu').on('show.bs.dropdown', function () {
    var i = $(this).parent().find('i')
    i.toggleClass('icon-down-open-1 icon-up-open-1');
  }).on('hide.bs.dropdown', function () {
    var i = $(this).parent().find('i')
    i.toggleClass('icon-up-open-1 iicon-down-open-1');
  });

  $('#membershipApplicationsDropdownMenu').on('hidden.bs.dropdown', function () {
    var i = $(this).parent().find('#dropdownMenuButton').html("I'm a..." + '<i class="icon-down-open-1" aria-hidden="true"></i>');
  });

  //Input Formatting for Date Inputs in Event Search

  var formatInputDate = function (id) {
    var date = document.getElementById(id);

    function checkValue(str, max) {
      if (str.charAt(0) !== '0' || str == '00') {
        var num = parseInt(str);
        if (isNaN(num) || num <= 0 || num > max) num = 1;
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
      };
      return str;
    };

    date.addEventListener('input', function (e) {
      this.type = 'text';
      var input = this.value;
      if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3);
      var values = input.split('/').map(function (v) {
        return v.replace(/\D/g, '')
      });
      if (values[0]) values[0] = checkValue(values[0], 12);
      if (values[1]) values[1] = checkValue(values[1], 31);
      var output = values.map(function (v, i) {
        return v.length == 2 && i < 2 ? v + ' / ' : v;
      });
      this.value = output.join('').substr(0, 14);
    });

    date.addEventListener('blur', function (e) {
      this.type = 'text';
      var input = this.value;
      var values = input.split('/').map(function (v, i) {
        return v.replace(/\D/g, '')
      });
      var output = '';

      if (values.length == 3) {
        var year = values[2].length !== 4 ? parseInt(values[2]) + 2000 : parseInt(values[2]);
        var month = parseInt(values[0]) - 1;
        var day = parseInt(values[1]);
        var d = new Date(year, month, day);
        if (!isNaN(d)) {
          // document.getElementById('result').innerText = d.toString();
          var dates = [d.getMonth() + 1, d.getDate(), d.getFullYear()];
          output = dates.map(function (v) {
            v = v.toString();
            return v.length == 1 ? '0' + v : v;
          }).join(' / ');
        };
      };
      this.value = output;
    });
  }

  //Check to see if Inputs are on the page before calling the function. To avoid errors in the console.
  if ($('#eventSearchStartDate').length) {
    formatInputDate('eventSearchStartDate');
  }

  if ($('#eventSeachEndDate').length) {
    formatInputDate('eventSeachEndDate');
  }

  //Text Search Highlighting for Events Search

  $(function () {
    var mark = function () {
      var options = {
        "element": "span",
        "className": "mark"
      }
      // Read the keyword
      var keyword = $("input[name='keyword']").val();
      // Remove previous marked elements and mark
      // the new keyword inside the context
      $(".eventPreviewText").unmark({
        done: function () {
          $(".eventPreviewText").mark(keyword, options);
        }
      });
    };
    $("input[name='keyword']").on("input", mark);
  });

  //Symposium / Conference Speaker List Filtering By Last Name

  var $speakerListItemContainer = $('.speakerListItemContainer');
  var $speakerListItem = $('.speakerListItem');


  $('#filterByLastName').on('click', function (e) {
    // $speakerListItem.detach().prependTo($speakerListItemContainer);
    $('.noSpeakersFoundMessage').removeClass('d-flex').addClass('d-none');
  });

  $('#filterByLastName').on('change', function (e) {
    $speakerListItem.detach().prependTo($speakerListItemContainer);
    e.preventDefault();
    var selectLastNameValue = $(this).val();
    var filteredSpeakerItems = [];
    if (selectLastNameValue === 'all') {
      filteredSpeakerItems = $speakerListItem;
    } else {
      filteredSpeakerItems = jQuery.grep($speakerListItem, function (speakerItem) {
        return $(speakerItem).attr('data-lastNameLetter') === selectLastNameValue;
      });
    }
    $speakerListItem.detach();

    if ($(filteredSpeakerItems).length >= 1) {
      $(filteredSpeakerItems).prependTo($speakerListItemContainer);
    } else {
      $('.noSpeakersFoundMessage').removeClass('d-none').addClass('d-flex');
    }
  });

  //Filtering for Symposium Theme Topics

  $('input[type="checkbox"]').click(function () {
    if ($(this).attr("value") == "infrastructure-resiliency") {
      $(".infrastructure-resiliency").show();
    }
    if ($(this).attr("value") == "economics-finance") {
      $(".economics-finance").show();
    }
    if ($(this).attr("value") == "culture-diversity") {
      $(".culture-diversity").show();
    }
    if ($(this).attr("value") == "professional-development") {
      $(".professional-development").show();
    }
  });

  $('input[type="button"]').click(function () {
    if ($(this).attr("value") == "Reset") {
      $(".infrastructure-resiliency").hide();
      $(".economics-finance").hide();
      $(".culture-diversity").hide();
      $(".professional-development").hide();
    }
    $('input[type=checkbox]').each(function () {
      this.checked = false;
    });
  });

  $('.form-control').keypress(function (e) {
    if (e.which == 13) {
      e.preventDefault();
    }
  });

  $('.expandIcon').on('click', function (e) {
    e.preventDefault();
  });


  if ($('.programSpeakerHeading').length) {
    if ($('.relatedSpeakersContainer').length === 0) {
      $('.programSpeakerHeading').addClass('d-none');
    }
  }

  //Changing Container Classes for Case Studies and Calls to Action Pages Depending on how many Card Elements are Contained Within:
  var $callsToActionLandingPageMediaGallery = $('.callsToActionLandingPageMediaGallery');
  var $callsToActionLandingPageMediaGalleryCard = $('.callsToActionLandingPageMediaGallery .d-flex .card');
  var $callsToActionLandingPageMediaGalleryCardParagraph = $('.callsToActionLandingPageMediaGallery .d-flex .card .card-body .card-text');
  if ($($callsToActionLandingPageMediaGallery).length) {
    $callsToActionLandingPageMediaGallery.fadeTo('slow', 1);
    if ($callsToActionLandingPageMediaGalleryCard.length === 1) {
      $callsToActionLandingPageMediaGallery.parent().removeClass('containerNarrow').addClass('containerWide');
    }

    $.each($callsToActionLandingPageMediaGalleryCardParagraph, function (index, galleryCardParagraph) {
      if ($(galleryCardParagraph[index]).text() === "") {
        $(this).css('display', 'none');
      }
    });

  }

  if ($('#primaryAccordion').length) {
    $('#primaryAccordion').find('.icon-plus-1').wrap("<span class='accordionIconWrap'></span>")
  }

  if ($('.policyCornerPagingControls').length) {
    $('.policyCornerPagingControls').find('span').removeAttr('style');
    var $pagingControlSpans = $('.policyCornerPagingControls').find('span');
    $($pagingControlSpans).html(function (i, html) {
      return html.replace(/&nbsp;/g, '');
    });
    $('.SelectedPrev').parent().css('display', 'none');
    $('.SelectedNext').parent().css('display', 'none');
    $('.UnselectedPrev').html(' <i class="icon-left-open-big" aria-hidden="true"></i>');
    $('.UnselectedNext').html(' <i class="icon-right-open-big" aria-hidden="true"></i>');
  }



};

//Any AJAX Calls for OPPI site.
oppiSite.ajaxCalls = function () {

  $('.primaryNewsAndEvents').fadeTo('slow', 1);

  //Snippet Below Is For Removing Inline Styles Coming from Web Service
  function remove_style(all) {
    var i = all.length;
    var j, is_hidden;

    // Presentational attributes.
    var attr = [
      'align',
      'background',
      'bgcolor',
      'border',
      'cellpadding',
      'cellspacing',
      'color',
      'face',
      'height',
      'hspace',
      'marginheight',
      'marginwidth',
      'noshade',
      'nowrap',
      'valign',
      'vspace',
      'width',
      'vlink',
      'alink',
      'text',
      'link',
      'frame',
      'frameborder',
      'clear',
      'scrolling',
      'style'
    ];

    var attr_len = attr.length;

    while (i--) {
      is_hidden = (all[i].style.display === 'none');

      j = attr_len;

      while (j--) {
        all[i].removeAttribute(attr[j]);
      }
      // Re-hide display:none elements,
      // so they can be toggled via JS.
      if (is_hidden) {
        all[i].style.display = 'none';
        is_hidden = false;
      }
    }
  }

  $('.primaryEventsSearch .dropdown .btn').html('All <i class="icon-down-open-1" aria-hidden="true"></i>');


  var eventsData = [];
  var unfilteredDropdownCategories = [];
  var $eventsAjaxContainer = $('.eventsAjaxContainer');
  var $eventPreviewCard = $('.eventPreviewCard');
  var $eventPreviewDate = $eventPreviewCard.find('.eventPreviewDate p');
  var $eventPreviewTitle = $eventPreviewCard.find('h5 a');
  var $eventPreviewDistrict = $eventPreviewCard.find('.districtHeading');
  var $eventPreviewCategory = $eventPreviewCard.find('.eventCategory');
  var $eventPreviewTime = $eventPreviewCard.find('.eventTime');
  var $eventPreviewLocation = $eventPreviewCard.find('.eventLocation');

  var showOppiEvents = function () {
    $.each(eventsData, function (key, event) {
      unfilteredDropdownCategories.push(event.EventType);
      var eventExternalLink = 'https://events.ontarioplanners.ca/Events/Details.aspx?Id=' + event.ExternalID + '';
      var formattedDataDate = moment(event.StartDate).format('YYYY/MM/DD');
      var formattedDataEndDate = moment(event.EndDate).format('YYYY/MM/DD');
      var formattedDateMonth = moment(event.StartDate).format("MMM");
      var formattedDateDay = moment(event.StartDate).format("DD");
      var formattedStartTime = moment(event.StartDate).format("h:mm A MMMM DD YYYY");
      var formattedStartTimeUpdated = moment(event.StartDate).format("hh:mm A");
      $eventPreviewCard.attr('data-date', formattedDataDate);
      $eventPreviewCard.attr('data-enddate', formattedDataEndDate);
      $eventPreviewCard.attr('data-category', event.EventType);
      $eventPreviewDate.html(formattedDateMonth + '<br>' + formattedDateDay);
      $eventPreviewTitle.text(event.DisplayName);
      $eventPreviewTitle.attr('href', eventExternalLink);
      $eventPreviewDistrict.text('District: ' + event.District);
      $eventPreviewCategory.text(event.EventType);
      // $eventPreviewTime.text(formattedStartTime);
      $eventPreviewTime.text(formattedStartTimeUpdated);
      $eventPreviewLocation.html(event.Location);
      $eventPreviewCard.clone().prependTo($eventsAjaxContainer);
    });

    $eventPreviewCard.detach();

    var set = $('.eventLocation').find('*');
    remove_style(set);

    sortOppiEvents();
    populateEventCategoryDropdown();
  }

  var sortOppiEvents = function () {

    var $eventsAjaxContainer = $('.eventsAjaxContainer');
    var $eventPreviewCard = $('.eventPreviewCard');

    $eventPreviewCard.sort(function (a, b) {
      var aDataDate = a.getAttribute('data-date')
      var bDataDate = b.getAttribute('data-date');
      if (aDataDate > bDataDate) {
        return 1;
      }
      if (aDataDate < bDataDate) {
        return -1;
      }
      return 0;
    });

    $eventPreviewCard.detach().prependTo($eventsAjaxContainer);
  }

  var populateEventCategoryDropdown = function () {

    var uniqueFilterDropdownCategories = [];

    $.each(unfilteredDropdownCategories, function (i, el) {
      if ($.inArray(el, uniqueFilterDropdownCategories) === -1) uniqueFilterDropdownCategories.push(el);
    });

    var $primaryEventsSearchDropdownMenu = $('.primaryEventsSearch .dropdown-menu');
    var $primaryEventsSearchDropdownItem = $primaryEventsSearchDropdownMenu.find('.dropdown-item');
    $primaryEventsSearchDropdownItem.clone().prependTo($primaryEventsSearchDropdownMenu);

    if ($primaryEventsSearchDropdownItem.length < uniqueFilterDropdownCategories.length + 1) {
      $.each(uniqueFilterDropdownCategories, function (key, category) {
        $primaryEventsSearchDropdownItem.attr('data-link', category);
        $primaryEventsSearchDropdownItem.text(category);
        $primaryEventsSearchDropdownItem.clone().appendTo($primaryEventsSearchDropdownMenu);
      });
    }
    $primaryEventsSearchDropdownItem.detach();
    sortEventDropdownItems();
  }

  var sortEventDropdownItems = function () {

    var $primaryEventsSearchDropdownMenu = $('.primaryEventsSearch .dropdown-menu');
    var $primaryEventsSearchDropdownItem = $primaryEventsSearchDropdownMenu.find('.dropdown-item');

    $primaryEventsSearchDropdownItem.sort(function (a, b) {
      var aDataLink = a.getAttribute('data-link')
      var bDataLink = b.getAttribute('data-link');
      if (aDataLink > bDataLink) {
        return 1;
      }
      if (aDataLink < bDataLink) {
        return -1;
      }
      return 0;
    });

    $primaryEventsSearchDropdownItem.detach().prependTo($primaryEventsSearchDropdownMenu);

    eventSearchDropdownClickEvent();
  }

  var eventSearchDropdownClickEvent = function () {

    var $primaryEventsSearchDropdownMenu = $('.primaryEventsSearch .dropdown-menu');
    var $primaryEventsSearchDropdownItem = $primaryEventsSearchDropdownMenu.find('.dropdown-item');

    $primaryEventsSearchDropdownItem.on('click', function (e) {
      e.preventDefault();
      $('.primaryEventsSearch .dropdown .btn').html($(this).text() + '<i class="icon-down-open-1" aria-hidden="true"></i>');
      $('.primaryEventsSearch .dropdown .btn').attr('data-value', $(this).text());
    });

    searchEventPreviewCards();

  }

  var searchEventPreviewCards = function () {
    jQuery.expr[':'].Contains = function (a, i, m) {
      return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
    };

    $('.primaryEventsSearchSubmit').on('click', function (e) {

      e.preventDefault();
      var eventSearchStartDate = $('#eventSearchStartDate').val();
      var eventSearchEndDate = $('#eventSeachEndDate').val();
      var eventSearchDropDownValue = $('.primaryEventsSearch .dropdown .btn').attr('data-value');
      var searchKeywords = $('#eventSeachKeywords').val();

      eventSearchStartDate = eventSearchStartDate.replace(/\s+/g, '');
      eventSearchEndDate = eventSearchEndDate.replace(/\s+/g, '');

      var convertedEventSearchStartDate = moment(eventSearchStartDate, "M/D/YYYY").format('YYYY/MM/DD');
      var convertedEventSearchEndDate = moment(eventSearchEndDate, "M/D/YYYY").format('YYYY/MM/DD');

      var selectedCards = [];

      var $eventsAjaxContainer = $('.eventsAjaxContainer');
      var $eventPreviewCard = $('.eventPreviewCard');

      var unfilteredEventStartDates = [];
      var unfilteredEventEndDates = [];


      $(".eventPreviewCard:Contains(" + searchKeywords + ")").addClass('containsSearchText');

      $.each($eventPreviewCard, function (key, eventCard) {
        unfilteredEventStartDates.push($(eventCard).attr('data-date'));
        unfilteredEventEndDates.push($(eventCard).attr('data-enddate'));
        if ($(eventCard).hasClass('containsSearchText')) {
          selectedCards.push($(this));
        }
      });

      var filteredEventStartDates = [];

      $.each(unfilteredEventStartDates, function (i, el) {
        if ($.inArray(el, filteredEventStartDates) === -1) filteredEventStartDates.push(el);
      });

      var filteredEventEndDates = [];

      $.each(unfilteredEventEndDates, function (i, el) {
        if ($.inArray(el, filteredEventEndDates) === -1) filteredEventEndDates.push(el);
      });

      var validStartDate;
      var validEndDate;

      if (jQuery.inArray(convertedEventSearchStartDate, filteredEventStartDates) !== -1) {
        validStartDate = convertedEventSearchStartDate;
      }

      if (jQuery.inArray(convertedEventSearchEndDate, filteredEventEndDates) !== -1) {
        validEndDate = convertedEventSearchEndDate;
      }

      // if (validStartDate != undefined && validEndDate != undefined) {
      //   selectedCards = jQuery.grep(selectedCards, function (card) {
      //     var cardDataDate = moment(card.attr('data-date'), 'YYYY/MM/DD').toISOString();
      //     var isoStartDate = moment(validStartDate, 'YYYY/MM/DD').toISOString();
      //     var isoEndDate = moment(validEndDate, 'YYYY/MM/DD').toISOString();
      //     if (moment(cardDataDate).isSameOrAfter(isoStartDate) && moment(cardDataDate).isSameOrBefore(isoEndDate)) {
      //       return card;
      //     }
      //   });
      // }

      //Fixed Filter By Start and End Date Code Below:
      if (eventSearchStartDate != '' && eventSearchEndDate != '') {
        selectedCards = jQuery.grep(selectedCards, function (card) {
          var cardDataDate = moment(card.attr('data-date'), 'YYYY/MM/DD').toISOString();
          var isoStartDate = moment(eventSearchStartDate, 'MM/DD/YYYY').toISOString();
          var isoEndDate = moment(eventSearchEndDate, 'MM/DD/YYYY').toISOString();
          if (moment(cardDataDate).isSameOrAfter(isoStartDate) && moment(cardDataDate).isSameOrBefore(isoEndDate)) {
            return card;
          }
        });
      } else if (eventSearchStartDate != '' && eventSearchEndDate == '') {
        selectedCards = jQuery.grep(selectedCards, function (card) {
          var cardDataDate = moment(card.attr('data-date'), 'YYYY/MM/DD').toISOString();
          var isoStartDate = moment(eventSearchStartDate, 'MM/DD/YYYY').toISOString();
          if (moment(cardDataDate).isSameOrAfter(isoStartDate)) {
            return card;
          }
        });
      } else if (eventSearchStartDate == '' && eventSearchEndDate != '') {
        selectedCards = jQuery.grep(selectedCards, function (card) {
          var cardDataDate = moment(card.attr('data-date'), 'YYYY/MM/DD').toISOString();
          var isoEndDate = moment(eventSearchEndDate, 'MM/DD/YYYY').toISOString();
          if (moment(cardDataDate).isSameOrBefore(isoEndDate)) {
            return card;
          }
        });
      }

      if (eventSearchDropDownValue != 'All') {
        selectedCards = jQuery.grep(selectedCards, function (card) {
          return card.attr('data-category') === eventSearchDropDownValue;
        });
      }

      $eventPreviewCard.detach();

      $.each(selectedCards, function (key, selectCard) {
        $(selectCard).appendTo($eventsAjaxContainer);
      });

      $(this).removeClass('d-block').fadeOut().addClass('d-none');
      $('.primaryEventsSearchClear').removeClass('d-none').addClass('d-block');

      $('#eventSearchStartDate').attr('disabled', 'disabled');
      $('#eventSeachEndDate').attr('disabled', 'disabled');
      $('#dropdownMenuButton').attr('disabled', 'disabled');
      $('#eventSeachKeywords').attr('disabled', 'disabled');

    });

    $('.primaryEventsSearchClear').on('click', function (e) {
      e.preventDefault();
      $(this).removeClass('d-block').fadeOut().addClass('d-none');
      $('.primaryEventsSearchSubmit').removeClass('d-none').addClass('d-block');
      var $eventsAjaxContainer = $('.eventsAjaxContainer');
      var $eventPreviewCard = $('.eventPreviewCard');
      var $primaryEventsSearchDropdownMenu = $('.primaryEventsSearch .dropdown-menu');
      var $primaryEventsSearchDropdownItem = $primaryEventsSearchDropdownMenu.find('.dropdown-item');

      $('#eventSearchStartDate').val('');
      $('#eventSeachEndDate').val('');

      $('.primaryEventsSearch .dropdown .btn').html('All <i class="icon-down-open-1" aria-hidden="true"></i>');
      $('.primaryEventsSearch .dropdown .btn').attr('data-value', 'All');

      $('#eventSeachKeywords').val('');

      $eventPreviewCard.detach();
      showOppiEvents();
      $('#eventSearchStartDate').removeAttr('disabled');
      $('#eventSeachEndDate').removeAttr('disabled');
      $('#dropdownMenuButton').removeAttr('disabled');
      $('#eventSeachKeywords').removeAttr('disabled');
    });

    var eventsDate = [];
    $.each(eventsData, function (index, event) {
      var convertedDate = moment(event.StartDate).format('MM/DD/YYYY');
      eventsDate.push(convertedDate);
    });

    var createEventDatePicker = function () {
      $('#datepicker').multiDatesPicker({
        minDate: 0,
        dayNamesMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        // maxPicks: 1,
        pickableRange: 1,
        adjustRangeToDisabled: true,
        addDates: eventsDate,
        onSelect: function (date) {
          $('#datepicker').addClass('ui-state-disabled');
          filterEventsByDatePicker(date);
        }
      });
    };

    var createDisabledEventDatePicker = function () {
      $('#datepicker').multiDatesPicker({
        minDate: 0,
        dayNamesMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        // maxPicks: 1,
        pickableRange: 1,
        adjustRangeToDisabled: true,
        addDates: eventsDate
      });
    };

    createEventDatePicker();

    $('.ui-datepicker-today').nextAll().addClass('test-class');

    var $originalEventPreviewCards = $('.eventPreviewCard');

    var filterEventsByDatePicker = function (date) {
      $('#datepicker').multiDatesPicker('destroy');
      $('.primaryEventsDatepickerClear').removeClass('d-none').addClass('d-block');
      var currentClickedDate = moment(date, 'MM/DD/YYYY').format('YYYY/MM/DD');
      // console.log(currentClickedDate);

      var selectedCards = [];

      var $eventsAjaxContainer = $('.eventsAjaxContainer');
      var $eventPreviewCard = $('.eventPreviewCard');

      $.each($eventPreviewCard, function (key, eventCard) {
        if ($(eventCard).attr('data-date') === currentClickedDate) {
          selectedCards.push($(this));
        }
      });

      $eventPreviewCard.detach();
      $.each(selectedCards, function (key, selectCard) {
        $(selectCard).appendTo($eventsAjaxContainer);
      });

      createDisabledEventDatePicker();
      $('.primaryEventsSearch').addClass('ui-state-disabled');
    };

    $('.primaryEventsDatepickerClear').on('click', function (e) {
      e.preventDefault();
      $(this).removeClass('d-block').addClass('d-none');
      $('#datepicker').multiDatesPicker('destroy');
      $('#datepicker').removeClass('ui-state-disabled');
      $('.primaryEventsSearch').removeClass('ui-state-disabled');
      createEventDatePicker();
      var $eventPreviewCard = $('.eventPreviewCard');
      $eventPreviewCard.detach();
      $.each($originalEventPreviewCards, function (key, previewCard) {
        $(previewCard).appendTo($eventsAjaxContainer);
      });
    });
  }

  //Show District Page Events
  var showDistrictPageEvents = function (district) {

    var $districtEventsAjaxContainer = $('.districtEventsAjaxContainer');
    var $eventPreviewCard = $('.districtEventPreviewCard');
    var $eventPreviewDate = $eventPreviewCard.find('.eventPreviewDate p');
    var $eventPreviewTitle = $eventPreviewCard.find('h5 a');
    var $eventPreviewDistrict = $eventPreviewCard.find('.districtHeading');
    var $eventPreviewTime = $eventPreviewCard.find('.eventTime');
    var $eventPreviewLocation = $eventPreviewCard.find('.eventLocation');

    // console.log($eventPreviewCard);
    var showOppiDistrictEvents = function () {

      var torontoDistrictCategories = ["Ontario", "Toronto District"];
      var northernDistrictCategories = ["Ontario", "Northern District"];
      var easternDistrictCategories = ["Ontario", "Eastern District"];
      var westernLakeDistrictCategories = ["Ontario", "Western Lake Ontario District"];
      var southwestDistrictCategories = ["Ontario", "Southwest District"];
      var oakridgesDistrictCategories = ["Ontario", "Oak Ridges District"];
      var lakelandDistrictCategories = ["Ontario", "Lakeland District"];

      var districtEvents = [];

      if ($('#northernDistrict.primaryEventsPreviewContainer').length) {
        var districtEvents = jQuery.grep(eventsData, function (event) {
          return northernDistrictCategories.indexOf(event.District) > -1;
        });
      } else if ($('#easternDistrict.primaryEventsPreviewContainer').length) {
        var districtEvents = jQuery.grep(eventsData, function (event) {
          return easternDistrictCategories.indexOf(event.District) > -1;
        });
      } else if ($('#westernLakeOntarioDistrict.primaryEventsPreviewContainer').length) {
        var districtEvents = jQuery.grep(eventsData, function (event) {
          return westernLakeDistrictCategories.indexOf(event.District) > -1;
        });
      } else if ($('#southwestDistrict.primaryEventsPreviewContainer').length) {
        var districtEvents = jQuery.grep(eventsData, function (event) {
          return southwestDistrictCategories.indexOf(event.District) > -1;
        });
      } else if ($('#oakRidgesDistrict.primaryEventsPreviewContainer').length) {
        var districtEvents = jQuery.grep(eventsData, function (event) {
          return oakridgesDistrictCategories.indexOf(event.District) > -1;
        });
      } else if ($('#lakelandDistrict.primaryEventsPreviewContainer').length) {
        var districtEvents = jQuery.grep(eventsData, function (event) {
          return lakelandDistrictCategories.indexOf(event.District) > -1;
        });
      } else if ($('#torontoDistrict.primaryEventsPreviewContainer').length) {
        var districtEvents = jQuery.grep(eventsData, function (event) {
          return torontoDistrictCategories.indexOf(event.District) > -1;
        });
      }

      // console.log(districtEvents);

      $.each(districtEvents, function (key, event) {
        var eventExternalLink = 'https://events.ontarioplanners.ca/Events/Details.aspx?Id=' + event.ExternalID + '';
        var formattedDataDate = moment(event.StartDate).format('YYYY/MM/DD');
        var formattedDataEndDate = moment(event.EndDate).format('YYYY/MM/DD');
        var formattedDateMonth = moment(event.StartDate).format("MMM");
        var formattedDateDay = moment(event.StartDate).format("DD");
        var formattedStartTime = moment(event.StartDate).format("h:mm A MMMM DD YYYY");
        $eventPreviewCard.attr('data-date', formattedDataDate);
        $eventPreviewCard.attr('data-enddate', formattedDataEndDate);
        $eventPreviewCard.attr('data-category', event.EventType);
        $eventPreviewDate.html(formattedDateMonth + '<br>' + formattedDateDay);
        $eventPreviewTitle.text(event.DisplayName);
        $eventPreviewTitle.attr('href', eventExternalLink);
        $eventPreviewDistrict.text('District: ' + event.District);
        $eventPreviewTime.text(formattedStartTime);
        $eventPreviewLocation.html(event.Location);
        $eventPreviewCard.first().clone().prependTo($districtEventsAjaxContainer);
      });

      var set = $('.eventPreviewText').find('*');
      remove_style(set);
      // console.log($eventPreviewCard);
      $eventPreviewCard.detach();
      sortOppiDistrictEvents();
    }

    var sortOppiDistrictEvents = function () {

      var $districtEventsAjaxContainer = $('.districtEventsAjaxContainer');
      var $eventPreviewCard = $('.districtEventPreviewCard');

      // var uniqueEventPreviewCards = $.uniqueSort($eventPreviewCard);

      // console.log($eventPreviewCard);
      // console.log(uniqueEventPreviewCards);

      $eventPreviewCard.sort(function (a, b) {
        var aDataDate = a.getAttribute('data-date')
        var bDataDate = b.getAttribute('data-date');
        if (aDataDate > bDataDate) {
          return 1;
        }
        if (aDataDate < bDataDate) {
          return -1;
        }
        return 0;
      });
      // console.log($eventPreviewCard);
      $eventPreviewCard.detach().prependTo($districtEventsAjaxContainer);
    }

    if ($('#northernDistrict.primaryEventsPreviewContainer').length) {
      showOppiDistrictEvents('Northern District');
    } else if ($('#easternDistrict.primaryEventsPreviewContainer').length) {
      showOppiDistrictEvents('Eastern District');
    } else if ($('#westernLakeOntarioDistrict.primaryEventsPreviewContainer').length) {
      showOppiDistrictEvents('Western Lake Ontario District');
    } else if ($('#southwestDistrict.primaryEventsPreviewContainer').length) {
      showOppiDistrictEvents('Southwest District');
    } else if ($('#oakRidgesDistrict.primaryEventsPreviewContainer').length) {
      showOppiDistrictEvents('Oak Ridges District');
    } else if ($('#lakelandDistrict.primaryEventsPreviewContainer').length) {
      showOppiDistrictEvents('Lakeland District');
    } else if ($('#torontoDistrict.primaryEventsPreviewContainer').length) {
      showOppiDistrictEvents('Toronto District');
    }
  }

  $(function () {
    $.ajax({
      //Change URL below when going to live:
      // url: 'http://oppi2018.78beta.com/OPPI_Services/EventsJSON.ashx',
      url: '/OPPI_Services/EventsJSON.ashx',
      //url: 'OPPI_Services/EventsJSON.ashx',
      method: 'GET',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      success: function (res) {
        // console.log(res)
        // eventsData = res;
        var allEventsData = res;
        var todaysDate = moment().format('YYYY-MM-DD');
        var currentEvents = [];

        $.each(allEventsData, function (index, Event) {
          var eventStartDate = moment(Event.StartDate).format('YYYY-MM-DD');
          var eventEndDate = moment(Event.EndDate).format('YYYY-MM-DD');
          // if (moment(eventStartDate).isSameOrAfter(todaysDate)) {
          //   currentEvents.push(Event);
          // }
          // Modifying to Filter Events by End Date insteat of Start Date
          if (moment(eventEndDate).isSameOrAfter(todaysDate)) {
            currentEvents.push(Event);
          }
        });
        eventsData = currentEvents;
        showOppiEvents();
        showDistrictPageEvents();
      },
      error: function (error) {
        console.log("There was an error retrieving Event Data: " + JSON.stringify(error));
      }
    });
  });

};

//Lazy Load Images Function
oppiSite.lazyLoadImages = function () {
  checkNotLoadedImages();
  $(window).scroll(function () {
    checkNotLoadedImages();
  });

  function checkNotLoadedImages() {

    $('.blogPreviewCardImage').each(function () {
      var $cardImg = $(this);
      if (isInViewPort($cardImg)) {
        $cardImg.attr("src", $cardImg.data("src"));
      }
    });

    $('.spotlightImage').each(function () {
      var $cardImg = $(this);
      if (isInViewPort($cardImg)) {
        $cardImg.attr("src", $cardImg.data("src"));
      }
    });
  }

  function isInViewPort($element) {
    var rect = $element[0].getBoundingClientRect();
    var viewport = document.documentElement;
    return (rect.top >= 0 && (rect.bottom - 350) <= (window.innerHeight || viewport.clientHeight));
  }
};

oppiSite.initSplitSlider = function() {

  $('.split-slideshow').fadeTo('fast', 1);

  /* == Requires Slick.js and jQuery Mousewheel as well as _slick.scss == */
  var $slider = $('.slideshow .slider'),
    maxItems = $('.item', $slider).length,
    dragging = false,
    tracking,
    rightTracking;

  $sliderRight = $('.slideshow').clone().addClass('slideshow-right').appendTo($('.split-slideshow'));

  rightItems = $('.item', $sliderRight).toArray();
  reverseItems = rightItems.reverse();
  $('.slider', $sliderRight).html('');
  for (i = 0; i < maxItems; i++) {
    $(reverseItems[i]).appendTo($('.slider', $sliderRight));
  }

  var $rightSlider = $('.slideshow-right .slider');


  $('.slideshow-right').addClass('initial');

  setTimeout(function(){
    $('.slideshow-right').removeClass('initial');
  }, 300);

  $slider.addClass('initial');

  setTimeout(function(){
    $slider.removeClass('initial');
  }, 300);


  // $('.slideshow-left').addClass('initial');

  // setTimeout(function(){
  //   $('.slideshow-left').removeClass('initial');
  // }, 1000);

  var $slideshowText = $('.slideshow-text');

  var $sliderItemText = $('.sliderItemText');

  // $sliderItemText.appendTo($slideshowText);

  $slider.addClass('slideshow-left');

  // $('.slick-current.slick-active').find($sliderItemText).clone().appendTo($slideshowText);

  // $(document).one('ready', function(){
  //   $.each($sliderItemText, function (index, sliderItemText) { 
  //      if (index === 0) {
  //        $(sliderItemText).find('.heroCarouselTagLine').addClass('animated fadeInUp');
  //        $(sliderItemText).find('.oppiCrestContainer').addClass('animated delay-2s fadeInDownBig');
  //        $(sliderItemText).clone().appendTo($slideshowText);
  //      }  
  //    });
     
  // });

  // var $initialSliderItemText = $('.slideshow .slider.initial')

  // $.each($initialSliderItemText, function (index, sliderItemText) { 
  //     if (index === 0) {
  //       $(sliderItemText).find('.heroCarouselTagLine').addClass('animated fadeInUp');
  //       $(sliderItemText).find('.oppiCrestContainer').addClass('animated delay-2s fadeInDownBig');
  //       $(sliderItemText).clone().appendTo($slideshowText);
  //     }  
  //   });

  var setupInitialSliderText = function() {
    $.each($sliderItemText, function (index, sliderItemText) { 
      if (index === 0) {
        var $sliderTextClone = $(sliderItemText).clone();
        $($sliderTextClone).find('.yellowRectangle').addClass('animated delay-1s fadeIn');
        $($sliderTextClone).find('.heroCarouselReadMoreButton').addClass('animated delay-2s fadeInUp');
        $($sliderTextClone).find('.heroCarouselNewTaglineContainerLeft .heroCarouselTagLine').addClass('animated delay-1s fadeInDown');
        $($sliderTextClone).find('.heroCarouselNewTaglineContainerRight .heroCarouselTagLine').addClass('animated delay-1s fadeInUp');
        $($sliderTextClone).find('.heroCarouselContentMainLeft .heroCarouselIssueHeading').addClass('animated delay-1s fadeInDown');
        $($sliderTextClone).find('.heroCarouselContentNewRight .heroCarouselIssueHeading').addClass('animated delay-1s fadeInUp');
        $($sliderTextClone).find('.oppiCrestContainer').addClass('animated delay-3s fast stampAnimation');
        $($sliderTextClone).find('.heroCarouselIssueDescription').addClass('animated delay-1s fadeInDown');
        $($sliderTextClone).find('.heroCarouselSolutionDescription').addClass('animated delay-1s fadeInUp');
        $($sliderTextClone).appendTo($slideshowText);
      }  
    });
  }

  function once(fn, context) { 
    var result;

    return function() { 
      if(fn) {
        result = fn.apply(context || this, arguments);
        fn = null;
      }

      return result;
    };
  }

  // Usage
  var canOnlyFireOnce = once(function() {
    // console.log('Fired!');
    setupInitialSliderText();
  });

  canOnlyFireOnce();

  // setupInitialSliderText();

  
  $('.slideshow-left').slick({
    // Code below is to Enable Autoplay:
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: false,
    vertical: true,
    verticalSwiping: false,
    arrows: false,
    infinite: true,
    dots: true,
    speed: 1000,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)'
  // }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  //   if (currentSlide > nextSlide && nextSlide == 0 && currentSlide == maxItems - 1) {
  //     $rightSlider.slick('slickGoTo', maxItems - 1 - nextSlide);
  //     $slideshowText.slick('slickGoTo', maxItems);
  //   } else if (currentSlide < nextSlide && currentSlide == 0 && nextSlide == maxItems - 1) {
  //     $rightSlider.slick('slickGoTo', maxItems - 1 - nextSlide);
  //     $slideshowText.slick('slickGoTo', -1);
  //   } else {
  //     $rightSlider.slick('slickGoTo', maxItems - 1 - nextSlide);
  //     $slideshowText.slick('slickGoTo', nextSlide);
  //   }
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {

    var $sliderItemText = $('.sliderItemText');

    var nextSliderTextItem = $sliderItemText[nextSlide + 1];

    $slideshowText.empty();

    // var $sliderTextClone = $('.slick-current.slick-active').next('.slick-slide').find($sliderItemText).first().clone();
    var $sliderTextClone = $(nextSliderTextItem).first().clone();

    $($sliderTextClone).find('.yellowRectangle').addClass('animated fadeIn');
    $($sliderTextClone).find('.heroCarouselNewTaglineContainerLeft .heroCarouselTagLine').addClass('animated fast fadeIn');
    $($sliderTextClone).find('.heroCarouselNewTaglineContainerRight .heroCarouselTagLine').addClass('animated fast fadeIn');
    $($sliderTextClone).find('.heroCarouselContentMainLeft .heroCarouselIssueHeading').addClass('animated fast fadeIn');
    $($sliderTextClone).find('.heroCarouselContentNewRight .heroCarouselIssueHeading').addClass('animated fast fadeIn');

    $($sliderTextClone).find('.heroCarouselIssueDescription').addClass('animated fadeInDown');
    $($sliderTextClone).find('.heroCarouselSolutionDescription').addClass('animated fadeInUp');
    $($sliderTextClone).find('.heroCarouselButtonContainer').addClass('animated delay-1s fadeInUp');
    $($sliderTextClone).find('.oppiCrestContainer').addClass('animated delay-2s fast stampAnimation');
    $($sliderTextClone).appendTo($slideshowText);

    if (currentSlide > nextSlide && nextSlide == 0 && currentSlide == maxItems - 1) {
      // console.log('This is condition 1');
      // $rightSlider.slick('slickGoTo', maxItems - 1 - nextSlide);
      // $rightSlider.slick('slickPrev');
      // $rightSlider.slick('slickGoTo', maxItems - 1 - nextSlide);
      // $slideshowText.slick('slickGoTo', maxItems);
      $rightSlider.slick('slickGoTo', -1);
      // $rightSlider.slick('slickGoTo', +1);
      // $slideshowText.slick('slickGoTo', maxItems);
    } else if (currentSlide < nextSlide && currentSlide == 0 && nextSlide == maxItems - 1) {
      // console.log('This is condition 2');
      $rightSlider.slick('slickGoTo', maxItems - 1 - nextSlide);
      // $slideshowText.slick('slickGoTo', -1);
    } else {
      // console.log('This is condition 3');
      $rightSlider.slick('slickGoTo', maxItems - 1 - nextSlide);
      // $slideshowText.slick('slickGoTo', nextSlide);
    }
  }).on('afterChange', function (event, slick, currentSlide, nextSlide) {

  });

  $('.slideshow-right .slider').slick({
    // rtl: true,
    pauseOnHover: false,
    swipe: false,
    vertical: true,
    arrows: false,
    infinite: true,
    // speed: 950,
    speed: 1000,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    initialSlide: maxItems - 1
  });

  var $slickButtonListItems = $('.slick-dots li');

  // console.log($slickButtonListItems);

  // if($slickButtonListItems.length === 2) {
  //   console.log('There are two!');
  //   $.each($slickButtonListItems, function (index, slickListButton) { 
  //      console.log(index);
  //      if(index === 0) {
  //       // if (currentSlide > nextSlide && nextSlide == 0 && currentSlide == maxItems - 1) {
  //       //   $rightSlider.slick('slickGoTo', -1);
  //       // }
  //        $(slickListButton).on('click', function(e){
  //         //  e.stopPropagation();
  //         //  e.stopImmediatePropagation();
  //         //  e.preventDefault();
  //         //  $('.slideshow-right .slider').slick('slickGoTo', +1);
  //           console.log('First Slick Button Clicked');
  //           $('.slideshow-right .slider').slick('slickGoTo', -1);
  //        });
  //      }
  //   });

  // } else {
  //   console.log('There are more than 2!');
  // }

  // $('.slideshow-text').slick({
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   speed: 500,
  //   fade: true,
  //   cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)'
  // });
  // });
  
  // var $heroCarouselReadMoreButtons = $('.heroCarouselReadMoreButton');

  // $heroCarouselReadMoreButtons.mouseover(function() {
  //   $heroCarouselReadMoreButtons.addClass('active');
  // });

  // $heroCarouselReadMoreButtons.mouseleave(function() {
  //   $heroCarouselReadMoreButtons.removeClass('active');
  // });

  /* ==== End of Header Split Screen Carousel Code ==== */

};

//Initializing all Code within one INIT Function
oppiSite.init = function () {

  //All functions etc needed for Site.
  oppiSite.initBootstrapPlugins();
  oppiSite.initGalleryPlugins();
  oppiSite.initGoogleCharts();
  oppiSite.userEvents();
  oppiSite.ajaxCalls();
  oppiSite.lazyLoadImages();
  oppiSite.initSplitSlider();
};

//Initializing the JS for the Website Inside the Document Ready - Calling the INIT Function
$(document).ready(function () {
  oppiSite.init();
});
